import Paper from '@mui/material/Paper'
import { DataGridPremium } from '@mui/x-data-grid-premium/DataGridPremium'
import { FC } from 'react'
import { DataLogger, DataLoggerIntervalHistory } from 'src/api'
import { TableToolbar } from 'src/components/ui'
import { DataLoggerIntervalGridColumns } from './dataLoggerColumns'

interface Props {
  dataLogger: DataLogger
}

const columns = [
  DataLoggerIntervalGridColumns.Interval,
  DataLoggerIntervalGridColumns.Status,
  DataLoggerIntervalGridColumns.EndedAt,
  DataLoggerIntervalGridColumns.CreatedAt,
]

export const DataLoggerIntervals: FC<Props> = ({ dataLogger }) => {
  const intervalHistory = dataLogger?.intervalHistory || []
  const exportedFileName = `${document.title}_intervals`

  return (
    <Paper sx={{ flexGrow: 1, minHeight: '200px', width: "100%" }}>
      <DataGridPremium<DataLoggerIntervalHistory>
        autoHeight={true}
        disableRowSelectionOnClick
        rows={intervalHistory}
        columns={columns}
        rowThreshold={2}
        columnThreshold={2}
        localeText={{
          columnMenuSortAsc: "Sort A-Z",
          columnMenuSortDesc: "Sort Z-A",
        }}
        slots={{
          toolbar: () => <TableToolbar exportedFileName={exportedFileName} />
        }}
        sx={(theme) => ({
          border: "none",
          "& .MuiDataGrid-columnHeaderTitleContainerContent": {
            paddingLeft: "5px",
            overflow: "visible",
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            whiteSpace: "normal",
            lineHeight: 1,
            fontSize: "13px",
            fontWeight: 400,
            color: "rgba(0, 0, 0, 0.6)",
            overflow: "visible",
          },
        })}
      />
    </Paper>
  )
}
